var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.courses.length > 0)?_c('div',[_c('b-form-select',{attrs:{"options":_vm.options,"size":"sm"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }